import React from 'react'
import {connect} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {SortingFieldsWithResult} from 'jbc-front/components/SearchForm'
import {selector} from 'employees/list/utils'

const limits = ['10', '20', '50', '100', '200'].map((ele) => ({value: ele, label: `${ele}件を表示`}))
const sortTypes = [
  {value: 'staff_code__asc', label: 'スタッフコード 昇順'},
  {value: 'staff_code__desc', label: 'スタッフコード 降順'},
  {value: 'full_name_kana__asc', label: '氏名 昇順'},
  {value: 'full_name_kana__desc', label: '氏名 降順'},
  {value: 'office__asc', label: '適用事業所 設定順'},
  {value: 'office__desc', label: '適用事業所 設定逆順'},
  {value: 'employment_type__asc', label: '雇用形態 設定順'},
  {value: 'employment_type__desc', label: '雇用形態 設定逆順'},
  {value: 'group__asc', label: 'グループ 設定順'},
  {value: 'group__desc', label: 'グループ 設定逆順'},
  {value: 'position__asc', label: '役職 設定順'},
  {value: 'position__desc', label: '役職 設定逆順'},
  {value: 'occupation__asc', label: '職種 設定順'},
  {value: 'occupation__desc', label: '職種 設定逆順'},
  {value: 'joined_at__desc', label: '入社日 新しい順'},
  {value: 'joined_at__asc', label: '入社日 古い順'},
  {value: 'retired_at__desc', label: '退社日 新しい順'},
  {value: 'retired_at__asc', label: '退社日 古い順'},
]
const mapStateToProps = (state, {pathname}) => ({
  pathname,
  count: state.employees.list.count,
  limits,
  sortTypes,
  page: selector(state, 'page'),
  isLoading: state.employees.list.loading,
})

const ConnectedSortingFieldsWithResult = connect(mapStateToProps)(SortingFieldsWithResult)

const SortingFieldsWithResultContainer = (props) => {
  const {pathname} = useLocation()
  return <ConnectedSortingFieldsWithResult {...props} pathname={pathname} />
}

export default SortingFieldsWithResultContainer
